import React from 'react';


const CycloneAdvisory = () => {
  return (
<div className="cyclone-awareness">
<table
  className="advisory-table"
  style={{ width: "100%", borderCollapse: "collapse" }}
>
<thead style={{ backgroundColor: "rgb(225, 232, 242)" }}>
  <tr>
    <th style={{ border: "1px solid #ccc", padding: "10px", textAlign: "center" }}>
      Type
    </th>
    <th style={{ border: "1px solid #ccc", padding: "10px", textAlign: "center" }}>
      Advisory in English
    </th>
    {/* <th style={{ border: "1px solid #ccc", padding: "10px", textAlign: "center" }}>
      Avizu iha lian Tetum
    </th> */}
  </tr>
</thead>
  <tbody>
    <tr>
      <td
        style={{
          border: "1px solid #ccc",
          padding: "10px",
          verticalAlign: "top",
        }}
      >
        When the Cyclone Starts
        <br />
        {/* <i>Kuandu Ciklone Komesa</i> */}
      </td>
      <td style={{ border: "1px solid #ccc", padding: "10px" }}>
        <ul>
          <li>
            Listen to local radio stations for weather warnings.
          </li>
          <li>Monitor warnings to stay updated and prepared.</li>
          <li>Share accurate information with others.</li>
          <li>Ignore and do not spread rumors to prevent panic.</li>
          <li>Trust only official sources of information.</li>
          <li>Continue your normal activities but remain alert.</li>
          <li>
            Stay alert for the next 24 hours if an alert is issued.
          </li>
        </ul>
      </td>
      {/* <td style={{ border: "1px solid #ccc", padding: "10px" }}>
        <ul>
          <li>Ouví rádio lokal atu hatene aviso tempu.</li>
          <li>Kontrola aviso sira ba preparasaun.</li>
          <li>Fahe informasaun loos ba ema seluk.</li>
          <li>Labele fahe boato, prevene paniku.</li>
          <li>Konsidera deit informasaun ofisiál.</li>
          <li>Konta kontinuatividade, mais estadu alerta.</li>
          <li>Halerta ba oras 24 se iha aviso fó.</li>
        </ul>
      </td> */}
    </tr>
    <tr>
      <td
        style={{
          border: "1px solid #ccc",
          padding: "10px",
          verticalAlign: "top",
        }}
      >
        When Your Area is Under Cyclone Warning
        <br />
        {/* <i>Kuandu Ita-Nia Área iha Avisu Ciklone</i> */}
      </td>
      <td style={{ border: "1px solid #ccc", padding: "10px" }}>
        <ul>
          <li>Evacuate early before routes are flooded.</li>
          <li>Don’t delay; avoid getting marooned.</li>
          <li>
            If your house is on high ground, stay there or evacuate if
            told.
          </li>
          <li>Board up windows or install storm shutters.</li>
          <li>Support outside doors with strong reinforcements.</li>
          <li>
            Paste paper strips on glass to reduce splinters if no
            boards.
          </li>
          <li>Store food and water in sealed containers.</li>
          <li>Move valuables to upper floors.</li>
          <li>Ensure emergency lights and torches work.</li>
          <li>Secure loose objects inside.</li>
          <li>Open windows opposite to wind direction.</li>
          <li>Prepare special diets if needed.</li>
          <li>If cyclone eye passes, stay indoors during lull.</li>
          <li>Switch off electricity mains.</li>
          <li>Remain calm.</li>
        </ul>
      </td>
      {/* <td style={{ border: "1px solid #ccc", padding: "10px" }}>
        <ul>
          <li>Sai sedu molok dalan tasi bee.</li>
          <li>Labele atras; evita ne'ebé isoladu.</li>
          <li>Se uma iha fatuk aas, hela. Se lae, sai.</li>
          <li>Taka janela ho madeira.</li>
          <li>Fó reforso ba odamatan liur.</li>
          <li>Se la iha madeira, fó fita iha vidru.</li>
          <li>Fó reserva ai-han no bee ne'ebé taka di'ak.</li>
          <li>Foti sasán importante ba andar aas.</li>
          <li>
            Konsidera luz emergencia no lanterna ne'ebé funsiona.
          </li>
          <li>Taka sasán loos iha laran uma.</li>
          <li>Loke janela iha parte ne'ebé vento la mai.</li>
          <li>Prepara han ne'ebé espesiál ba labarik/ema matenek.</li>
          <li>Se matan ciklone pasa, hela iha uma to'o remata.</li>
          <li>Taka eletrisidade prinipal.</li>
          <li>Hakarak tranquila.</li>
        </ul>
      </td> */}
    </tr>
    <tr>
      <td
        style={{
          border: "1px solid #ccc",
          padding: "10px",
          verticalAlign: "top",
        }}
      >
        When Evacuation is Instructed
        <br />
        {/* <i>Kuandu Evakuasaun Fó Instrusaun</i> */}
      </td>
      <td style={{ border: "1px solid #ccc", padding: "10px" }}>
        <ul>
          <li>Pack essentials for a few days.</li>
          <li>Go to the designated shelter.</li>
          <li>Don't worry about property — prioritize safety.</li>
          <li>Follow instructions in shelter.</li>
          <li>Stay in shelter until it’s safe to leave.</li>
        </ul>
      </td>
      {/* <td style={{ border: "1px solid #ccc", padding: "10px" }}>
        <ul>
          <li>Fó kbiit ba buat importante ba loron balun.</li>
          <li>Bai ba fatin proteksaun ne'ebé determina.</li>
          <li>Labele preocupa ho sasán, prioridade ba seguransa.</li>
          <li>Haree instruasaun iha fatin seguransa.</li>
          <li>Hela iha shelter to'o fó sai seguransa.</li>
        </ul>
      </td> */}
    </tr>
    <tr>
      <td
        style={{
          border: "1px solid #ccc",
          padding: "10px",
          verticalAlign: "top",
        }}
      >
        Post-Cyclone Measures
        <br />
        {/* <i>Medidas Depois Ciklone</i> */}
      </td>
      <td style={{ border: "1px solid #ccc", padding: "10px" }}>
        <ul>
          <li>Get vaccinated against post-cyclone diseases.</li>
          <li>Avoid loose or dangling wires and electric poles.</li>
          <li>If driving is necessary, proceed with caution.</li>
          <li>Clear debris from your property promptly.</li>
          <li>Report damages accurately to authorities.</li>
        </ul>
      </td>
      {/* <td style={{ border: "1px solid #ccc", padding: "10px" }}>
        <ul>
          <li>Hela iha shelter to'o fó sai seguransa.</li>
          <li>Fó vaksinasaun kontra moras post-ciklone.</li>
          <li>Evita kabu eletrisidade ne'ebé loos/dangling.</li>
          <li>Se presiza lori karreta, lori ho kuidadu boot.</li>
          <li>Limpia liman ba uma laran molok tempu naruk.</li>
          <li>
            Hato'o informasaun loos kona-ba estragu ba autoridade.
          </li>
        </ul>
      </td> */}
    </tr>
  </tbody>
</table>

Note: The report is valid until the specified [date and time]. Please monitor the website for additional information
and alerts issued by the Department of Meteorology.
</div>
  );
};

export default CycloneAdvisory;
